var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "gray"
    },
    d: "M483.556,453.86H53.276C23.9,453.86,0,429.959,0,400.583V111.417C0,82.041,23.9,58.14,53.276,58.14 h405.447c29.376,0,53.276,23.9,53.276,53.276v222.807c0,7.855-6.367,14.222-14.222,14.222s-14.222-6.367-14.222-14.222V111.417 c0-13.692-11.14-24.832-24.832-24.832H53.276c-13.692,0-24.832,11.14-24.832,24.832v289.166c0,13.692,11.14,24.832,24.832,24.832 h430.279c7.855,0,14.222,6.367,14.222,14.222S491.411,453.86,483.556,453.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(122, 152, 206)"
    },
    d: "M497.778,111.417L497.778,111.417L256,294.542L14.222,111.417l0,0 c0-21.569,17.485-39.054,39.054-39.054h405.447C480.293,72.363,497.778,89.847,497.778,111.417z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "gray"
    },
    d: "M256,308.764c-3.024,0-6.047-0.961-8.587-2.884L5.635,122.755C2.085,120.065,0,115.87,0,111.417 C0,82.041,23.9,58.14,53.276,58.14h405.447c29.376,0,53.276,23.9,53.276,53.276c0,4.453-2.085,8.649-5.635,11.338L264.587,305.88 C262.047,307.803,259.024,308.764,256,308.764z M29.288,104.987L256,276.7l226.712-171.713 c-2.84-10.586-12.518-18.402-23.989-18.402H53.276C41.808,86.585,32.128,94.401,29.288,104.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "gray"
    },
    d: "M483.544,453.662c-2.992,0-6.007-0.94-8.576-2.886l-99.556-75.405 c-6.262-4.742-7.494-13.663-2.751-19.924c4.743-6.262,13.663-7.494,19.924-2.751l99.556,75.405 c6.262,4.742,7.494,13.663,2.751,19.924C492.095,451.719,487.844,453.662,483.544,453.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "gray"
    },
    d: "M34.524,449.065c-4.301,0-8.55-1.943-11.348-5.636c-4.742-6.261-3.511-15.182,2.751-19.924 l93.487-70.808c6.261-4.74,15.181-3.511,19.924,2.751c4.742,6.261,3.511,15.182-2.751,19.924L43.102,446.18 C40.533,448.125,37.517,449.065,34.524,449.065z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSvgrepoCom);
export default __webpack_public_path__ + "static/media/mail-svgrepo-com.4f924db733c5a9e3a35dbdb677a79801.svg";
export { ForwardRef as ReactComponent };